export class TurnAutofillOff implements ng.IDirective {
    public restrict = 'A';

    public link = ($scope: any, $elem: ng.IAugmentedJQuery) => {
        if (!$elem.attr('name')) {
            $elem.attr('name', Math.random().toString(36).substring(2) + Date.now().toString(36));
        }
        if ($elem.attr('type') === 'password') {
            $elem.attr('autocomplete', 'new-password');
        } else {
            $elem.attr('autocomplete', 'off');
        }
    }
}